/**
 * The rewrites a stored skill has had. Each skill carries the ids it has been through
 * (`SavedSkill.migrations`), so a rewrite runs on the records that lack its id and on no other,
 * and a quarantined record keeps the rewrites it still lacks until it comes back.
 */

/** A knockback with no stated origin, saved before `from` existed, pushed away from the caster. */
export const MIGRATION_KNOCKBACK_ORIGIN = 'knockback-origin-pin-v1';
/** An instant toxic `damage` leaf is the toxic dot of the same power, priced again. */
export const MIGRATION_TOXIC_AS_POISON = 'toxic-damage-as-poison-v1';
/** Legacy workshop poison leaves with one refresh key keep the last delivered payload. */
export const MIGRATION_POISON_SINGLE_PATH = 'poison-status-single-path-v1';
/** The definition is stored in the loader's canonical form, displacement origins written out. */
export const MIGRATION_CANONICAL_FORM = 'canonical-form-v1';

/** Every rewrite this build knows, in the order they run. */
export const SAVED_SKILL_MIGRATIONS: readonly string[] = Object.freeze([MIGRATION_KNOCKBACK_ORIGIN, MIGRATION_TOXIC_AS_POISON, MIGRATION_POISON_SINGLE_PATH, MIGRATION_CANONICAL_FORM]);

/** The store carries something only a newer build understands; opening it here could lose it. */
export class NewerStoreError extends Error {
  constructor(message: string) { super(message); this.name = 'NewerStoreError'; }
}
